import React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { Container, Success } from '../components';
import { formatPrice, formatUfPrice } from '../helpers/utils';
import { restartFlow } from '../store/Commons';

interface ISuccessContainerProps {
  mail: string;
  priceUF: string;
  priceCLP: string;
  proposal: number;
  reset: () => void;
}

export function SuccessContainer(props: ISuccessContainerProps) {
  const { mail, priceUF, priceCLP, proposal, reset } = props;

  return (
    <Container>
      <Success
        email={mail}
        priceUF={priceUF}
        priceCLP={priceCLP}
        proposal={proposal}
        reset={reset}
      />
    </Container>
  );
}

export const mapStateToProps = (state: any) => {
  const {
    Quote: {
      planSelected: { premium_monthly = 0, premium_monthly_CLP = 0 },
    },
    Emit: {
      data: { mail },
      proposal: { number: proposal = 0 },
    },
  } = state;

  const priceCLP = formatPrice(premium_monthly_CLP);
  const priceUF = formatUfPrice(premium_monthly);

  return {
    mail,
    priceCLP,
    priceUF,
    proposal,
  };
};

export const mapDispatchToProps = (dispatch: Dispatch) => ({
  reset: () => dispatch(restartFlow()),
});

export default connect(mapStateToProps, mapDispatchToProps)(SuccessContainer);
